exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".LinkButtons1 .link-button{border-width:1px;border-style:solid}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/LinkButtons1/LinkButtons1.scss
// module id = 1007
// module chunks = 35